import { useState, useEffect } from "react";
import { UilLinkAlt } from '@iconscout/react-unicons';
import axios from "axios";

import "../App.css";
import carbonis from "../carbonis.png";

function DashboardTwo() {
    // Properties

    const baseUrl = "https://plum-defiant-lamb.cyclic.app/user";
    // const baseUrl = "localhost:8000/user";

    const [WalletAddress, setWalletAddress] = useState("");

    const [verified, setVerified] = useState(false);

    const [userDetails, setUserDetails] = useState('');

    const [userCount, setUserCount] = useState(1);

    // const [counter, setCounter] = useState('0');

    useEffect(() => {
        getCurrentWalletConnected();
        if (!userDetails) {
            setVerified(false);
            getUser();
        }
    });

    async function getUser() {
        try {
            const response = await axios.get(`${baseUrl}/details?wallet=${localStorage.getItem('wallet_address')}`);
            console.log('User data : ', response.data);
            if (response.data !== null) {
                setVerified(true);
                setUserDetails(response.data);
            }
        } catch (error) {
            console.error(error);
        }

        try {
            const userTotals = await axios.get(`${baseUrl}`);
            console.log('User data : ', userTotals.data);
            if (userTotals.data !== null) {
                setUserCount(userTotals.data);
            }

        } catch (error) {
            console.error(error);
        }
    }

    async function connectWallet() {
        // ❌ Check if Metamask exists
        if (typeof window.ethereum !== 'undefined') {
            console.log('Metamask detected')
            try {
                const accounts = await window.ethereum.request({
                    method: 'eth_requestAccounts',
                });
                setWalletAddress(accounts[0]);
                localStorage.setItem('wallet_address', accounts[0]);
            } catch (error) {
                console.log(error);
            }

        } else {
            console.log('Metamask not found')
        }
    }

    async function getCurrentWalletConnected() {
        if (typeof window.ethereum !== 'undefined') {
            try {
                const accounts = await window.ethereum.request({
                    method: 'eth_accounts',
                });
                if (accounts.length > 0) {
                    //setWalletAddress(accounts[0]);
                    console.log(accounts[0]);
                    localStorage.setItem('wallet_address', accounts[0]);
                    console.log(`WALLET FUCHING ADDRESS ${localStorage.getItem('wallet_address')}`);
                } else {
                    console.log('Please connect again');
                }
            } catch (error) {
                console.log(error);
            }

        } else {
            console.log('Metamask not found')
        }
    }

    async function disconnectWallet() {
        setWalletAddress("");
    }

    async function goToRegister() {
        window.location = '/register';
    }

    return (
        <div className="App container section">
            <div className="is-center">
                <img src={carbonis} style={{ width: '200px', marginBottom: "50px" }}></img>
            </div>
            {
                !WalletAddress.length > 0 ?
                    <div className="is-center"><h2> <strong className="white-text">Sign in to Carbonis Dashboard using your Web3 wallet</strong></h2>

                        <button onClick={connectWallet} className="button is-black margin-top-bottom-50" > <UilLinkAlt /> &nbsp;&nbsp;
                        Connect Wallet
                        </button>
                    </div>
                    :
                    <div className="is-center white-text">
                        <h2>
                            Wallet address : {WalletAddress}
                        </h2>

                        {!verified ? (goToRegister()) : (
                            <p>
                                Hello, welcome to Carbonis 🌳
                                {/* <strong>{userDetails.name}</strong> */}
                                <br />
                                You are already verified.
                                <br />
                                You are user number {userCount} out of 1000 founding members.

                            </p>
                        )}


                        {/* <img src={dashboardComingSoon}></img> */}

                    </div>
            }
        </div>
    );
}

export default DashboardTwo;